import template from "./instrument_type_list.html";
import controller from "./instrument_type_list.controller";

const component = {
  restrict: "E",
  bindings: {},
  template,
  controller,
};

export default component;
